import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import Navbar from "./components/feature/Navbar";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <Navbar />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
